import { useTheme } from '@mui/material/styles';

import { tss } from 'tss-react';

export const useStyles = tss.create(() => {
  const theme = useTheme();
  return {
    menu: {
      marginBottom: theme.spacing(1)
    },
    knowledgeGraphSwitcher: {
      margin: theme.spacing(1),
      marginTop: 0,
      paddingLeft: 12,
      paddingRight: 12
    },
    editorMenuContainer: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto'
    }
  };
});

export const loadingSx = {
  color: 'white',
  marginRight: 1
};
